import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackSavedSizeCreated.meta';

export type UseTrackSavedSizeCreatedParams = {
  source: 'canvas_picker' | 'crop' | 'context';
  size_preset_id: string;
  width: number;
  height: number;
};

export const useTrackSavedSizeCreated = () => {
  const { track } = useAnalyticsUtilities();

  const trackSavedSizeCreated = useCallback(
    (params: UseTrackSavedSizeCreatedParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackSavedSizeCreated };
};
